import type { InjectionKey } from "vue";

export interface Props {
  title?: string;
}

export interface ExcursionImageLoading {
  markImageGroupLoaded: () => void;
}

export const ExcursionImageLoadingKey: InjectionKey<ExcursionImageLoading> = Symbol("ExcursionImageLoading");
